import { useEffect, useState } from "react";

export default function ReportToc({ sections }) {
  const [activeSectionId, setActiveSectionId] = useState(sections[0]?.id || "");

  useEffect(() => {
    if (!sections.length) {
      return undefined;
    }

    const targets = sections
      .map((section) => document.getElementById(section.id))
      .filter(Boolean);

    if (!targets.length) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntries = entries
          .filter((entry) => entry.isIntersecting)
          .sort((left, right) => left.boundingClientRect.top - right.boundingClientRect.top);

        if (visibleEntries.length > 0) {
          setActiveSectionId(visibleEntries[0].target.id);
        }
      },
      {
        rootMargin: "-18% 0px -60% 0px",
        threshold: [0, 0.2, 0.5],
      },
    );

    targets.forEach((target) => observer.observe(target));

    return () => {
      targets.forEach((target) => observer.unobserve(target));
      observer.disconnect();
    };
  }, [sections]);

  if (!sections.length) {
    return null;
  }

  return (
    <aside className="panel report-toc-panel">
      <div className="panel-header">
        <div>
          <p className="eyebrow">Navigation</p>
          <h2>Table of Contents</h2>
        </div>
      </div>

      <nav className="report-toc-list" aria-label="Report table of contents">
        {sections.map((section) => (
          <button
            key={section.id}
            type="button"
            className={`report-toc-item ${activeSectionId === section.id ? "active" : ""} ${section.level ? `level-${section.level}` : ""}`}
            onClick={() => {
              document.getElementById(section.id)?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
          >
            <span className="report-toc-item-label">{section.label}</span>
            {section.pageNumber ? <span className="report-toc-item-page">{section.pageNumber}</span> : null}
          </button>
        ))}
      </nav>
    </aside>
  );
}
